'use strict';

exports['default'] = 'html';